PJQ.helpers.drawings = {
	createDownload: function (project, versions, options) {
		let params = [];
		if (options) {
			if (options.raster) {
				params.push({
					parameter: 'raster',
					value: options.raster
				});
			}
			if (options.merge) {
				params.push({
					parameter: 'merge',
					value: options.merge
				});
			}

			if (options.includeAttachments) {
				params.push({
					parameter: 'attachments',
					value: options.includeAttachments
				});
			}

			if (options.includeMyAnnotations || options.includePublishedAnnotations) {
				let annotationMode = 0;
				if (options.includeMyAnnotations && options.includePublishedAnnotations) {
					annotationMode = 3;
				}
				else if (options.includeMyAnnotations) {
					annotationMode = 1;
				}
				else if (options.includePublishedAnnotations) {
					annotationMode = 2;
				}
				params.push({
					parameter: 'annotationMode',
					value: annotationMode
				});
			}
		}

		if (_.size(PJQ.app.session.get('accessKey')) > 0) {
			params.push({
				parameter: 'accessKey',
				value: PJQ.app.session.get('accessKey')
			});
		}

		let versionsObj = {},
			arr = [];

		if (project != null) {
			arr.push({
				endpoint: 'projects',
				value: project.id
			});
		}
		arr.push({
			endpoint: 'drawings'
		});
		arr.push({
			endpoint: 'downloads'
		});

		_.each(versions, function (version) {
			versionsObj[version.versionId] = version.guids;
		});
		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint(arr, params),
			data = {
				versions: versionsObj
			};
		PJQ.files.queueDownload(endpoint, data);
	},
	getUnPublishedBatchesCount: function (projectId, callback) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: projectId
				},
				{
					endpoint: 'drawings'
				},
				{
					endpoint: 'batches'
				},
				{
					endpoint: 'unpublished'
				}
			])
		}).get().done(function (data) {
			callback(data.count);
		}).fail(function () {
			callback(null);
		});
	}
};